import { createTestId } from '../../common/selectors';

export const manageCompaniesSelector = createTestId(`settings-manage-companies`);
